import { useCallback, useState } from 'react';
import { getToken } from '../utils/auth';

// FormData uploads can't go through baseQuery (it always forces
// application/json headers), so this talks to the API directly - same
// pattern already used by useExportManager for blob downloads.
export const useManualUpload = () => {
  const [uploadState, setUploadState] = useState({
    isLoading: false,
    error: null,
    success: false,
  });

  const uploadCall = useCallback(async ({ phoneNumber, publisherName, audioFile }) => {
    setUploadState({ isLoading: true, error: null, success: false });

    try {
      const formData = new FormData();
      formData.append('phoneNumber', phoneNumber);
      formData.append('publisherName', publisherName);
      formData.append('audio', audioFile);

      const base = process.env.REACT_APP_API_BASE || '';
      const token = getToken();

      const response = await fetch(`${base}/api/manual-calls`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: formData,
      });

      const body = await response.json().catch(() => ({}));

      if (!response.ok || body?.success === false) {
        throw new Error(body?.error?.message || 'Upload failed');
      }

      setUploadState({ isLoading: false, error: null, success: true });
      return body.data;
    } catch (err) {
      setUploadState({ isLoading: false, error: err.message, success: false });
      throw err;
    }
  }, []);

  const resetUploadState = useCallback(() => {
    setUploadState({ isLoading: false, error: null, success: false });
  }, []);

  return { uploadState, uploadCall, resetUploadState };
};
